import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * @interface RolState
 * @description Define la forma del estado de rol gestionado por Zustand.
 */
interface RolState {
  /**
   * @property {number} idRol - El ID del rol seleccionado, o 0 si no hay rol seleccionado.
   */
  idRol: number;

  /**
   * @function setRol
   * @description Establece el ID del rol seleccionado.
   * @param {number} idRol - El ID del rol a establecer.
   */
  setRol: (idRol: number) => void;

  /**
   * @function clearRol
   * @description Limpia el ID del rol seleccionado.
   */
  clearRol: () => void;
}

/**
 * @constant useRolStore
 * @description Un almacén de Zustand para gestionar el estado del rol seleccionado.
 * El almacén se persiste en localStorage para mantener el estado entre sesiones del navegador.
 * @type {import('zustand').UseBoundStore<import('zustand').StoreApi<RolState>>}
 */
export const useRolStore = create<RolState>()(
  persist(
    (set) => ({
      idRol: 0,

      setRol: (idRol: number) => {
        set({ idRol });

      },

      clearRol: () => {
        set({ idRol: 0 });

      },
    }),
    {
      name: 'rol-storage',
      partialize: (state) => ({
        idRol: state.idRol,
      }),
    }
  )
);

